import React from 'react';
/*
 * This component is responsible for rendering a pane.
 * It takes props to populate the body as well as the footer.
 *
 * @author Cargomatic Engineering
 * @usage <CargomaticPane />
 *
 */
import PropTypes from 'prop-types';
import Drawer from 'rc-drawer';
const CargomaticPane = ({ container, className, show, width, renderBody, onHide, location, }) => {
    if (!show)
        return null;
    let widthTemp;
    if (width) {
        widthTemp = window.innerWidth * width;
    }
    return (React.createElement(Drawer, { getContainer: container, className: className, wrapperClassName: "cargomatic-pane-wrapper", maskClosable: true, width: widthTemp, open: show, placement: location, onClose: onHide, onHandleClick: onHide, showMask: true }, renderBody()));
};
CargomaticPane.propTypes = {
    container: PropTypes.string,
    show: PropTypes.bool, // Show the pane
    onHide: PropTypes.func.isRequired, // onHide Callback
    renderBody: PropTypes.func, // body component
    location: PropTypes.string, // Location of the pane vertically
    className: PropTypes.string,
    width: PropTypes.number,
};
CargomaticPane.defaultProps = {
    container: '#pane-container',
    show: true,
    location: 'right',
    width: 0.33,
};
export default CargomaticPane;
